class VariantPicker extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const variants = this.querySelectorAll("input.product-variant");
    for (const variant of variants) {
      variant.addEventListener("input", (event) => {
        this.updateDOM(variant.value);
      });
    }
  }
  updateDOM(optionValues) {
    const that = this;
    const sectionId = that.dataset.sectionId;
    const fetchUrl = this.updateURL(optionValues)
    fetchUrl.searchParams.set("sections", sectionId);
    that.classList.add("loading");
    fetch(fetchUrl, {
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        const template = document.createElement("template");
        template.innerHTML = data[sectionId].trim();
        const newVariant = template.content?.querySelector('#product-variant');
        const currentVariant = document.querySelector('#product-variant');
        if (!!newVariant && !!currentVariant) {
          currentVariant.replaceWith(newVariant);
        }
        
        that.classList.remove("loading");
      })
      .catch(function (err) {
        that.classList.remove("loading");
        console.error(err);
      });
  }
  updateURL(optionValues) {
    const newUrl = new URL(location);
    newUrl.searchParams.delete("variant");
    if (!!optionValues) {
      newUrl.searchParams.set("option_values", optionValues);
    } else {
      newUrl.searchParams.delete("option_values");
    }
    history.replaceState(null, "", newUrl.href);
    return newUrl;
  }
}
customElements.define("variant-picker", VariantPicker);

class FragrancePyramid extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const collapsibles = this.querySelectorAll('details')
    const additionalTrigger = document.querySelectorAll('slider-thumbnail');
    additionalTrigger.forEach(trigger => {
      const imageId = trigger.dataset.imageId;
      trigger.addEventListener('click', (event) => {
        this.updateImage(imageId, '.only-mobile .background-image');
      })
    })
    collapsibles.forEach(collapsible => {
      const trigger = collapsible.querySelector('summary');
      const imageId = collapsible.dataset.imageId;
      if (trigger) {
        trigger.addEventListener('click', (event) => {
          this.updateImage(imageId, '.only-desktop .background-image');
          const imgWidth = collapsible.querySelector('img')?.width + 15;
          trigger.style.setProperty('--slide-head', imgWidth + 'px');
        })
      }
    })
  }
  updateImage(imageId, query) {
    const currentImages = document.querySelectorAll(query);
    currentImages.forEach(image => {
      const currentImageId = image.dataset.imageId;
      if (currentImageId != imageId) {
        image.classList.add('hidden');
      } else {
        const video = image.querySelector('video');
        if (!!video) {
          video.currentTime = 1;
          video.play();
        }
        image.classList.remove('hidden');
      }
    })
  }
}
customElements.define("fragrance-pyramid", FragrancePyramid);

class SliderThumbnail extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const sliders = document.querySelectorAll('slider-thumbnail');
      sliders.forEach(slider => {
        slider.classList.remove('selected');
      })
      this.classList.add('selected');
      this.updateSlideshow(this.dataset.fragranceNote);
    })
  }
  updateSlideshow(_sliderId) {
    const container = this.closest('.collapsible-slider');
    const slideshows = container.querySelectorAll('slideshow-section');
    const staticSlideshow = container.querySelectorAll('static-slideshow-section');
    slideshows.forEach(slideshow => {
      const sliderId = slideshow.id;
      if (sliderId != _sliderId) {
        slideshow.classList.add('hidden')
      } else {
        slideshow.classList.remove('hidden')
      } 
    });
    staticSlideshow.forEach(slideshow => {
      const sliderId = slideshow.id;
      if (sliderId != _sliderId) {
        slideshow.classList.add('hidden')
      } else {
        slideshow.classList.remove('hidden')
        const check = slideshow.querySelector('details');
        if (check) {
          check.open = true;
        }
      }
    })
  }
}
customElements.define("slider-thumbnail", SliderThumbnail);
class ScrollImage extends HTMLElement {
  constructor() {
    super();
    this.anchor = document.querySelector('.image-anchor');
    this.updatePosition = this.updatePosition.bind(this)
  }
  connectedCallback() {
    document.addEventListener('DOMContentLoaded', (e) => {
      this.style.height = window.scrollY + this.anchor?.getBoundingClientRect()?.top - 290 + "px";
    })
    window.addEventListener('resize', this.updatePosition)
  }
  updatePosition() {
    this.style.height = window.scrollY + this.anchor?.getBoundingClientRect()?.top - 290 + "px";
  }
}
customElements.define("scroll-image", ScrollImage);

class ShortTab extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const header = this.closest('details');
      if (!!header) {
        header.open = false;
      }
    });
  }
}
customElements.define("short-tab", ShortTab);

class FragrancePyramidSlider extends HTMLElement {
  constructor() {
    super();
    this.isIntersecting = false;
    this.activeVideo = null;
  }
  connectedCallback() {
    this.slideshow = this.querySelector('slideshow-section');
    this.tabs = this.querySelectorAll('.fragrance-pyramid-slider__tab');
    this.steps = this.querySelectorAll('.fragrance-slider__progress-step');
    if (!this.slideshow) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const slides = this.slideshow.querySelectorAll('[data-swiper-slide]');
        this.slideshow.slideTo(slides[parseInt(tab.dataset.tabIndex, 10)]);
      });
    });

    this.onResize = () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.syncActiveVideo(), 200);
    };
    window.addEventListener('resize', this.onResize);

    this.checkInterval = setInterval(() => {
      const container = this.slideshow.querySelector('[data-swiper]');
      if (!container.classList.contains('swiper-initialized')) return;
      clearInterval(this.checkInterval);

      this.swiper = container.swiper;
      this.swiper.on('slideChange', () => this.handleSlideChange());
      this.handleSlideChange();

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.isIntersecting = entry.isIntersecting;
            this.syncActiveVideo();
          });
        },
        { threshold: 0.1 },
      );
      this.observer.observe(this);
    }, 100);
  }
  disconnectedCallback() {
    clearInterval(this.checkInterval);
    clearTimeout(this.resizeTimer);
    window.removeEventListener('resize', this.onResize);
    this.observer?.disconnect();
  }
  setActiveTab(index) {
    this.tabs.forEach((t) => {
      t.classList.toggle('selected', parseInt(t.dataset.tabIndex, 10) === index);
    });
  }
  updateProgressSteps(index, total) {
    this.steps.forEach((step) => {
      const isActive =
        (step.dataset.step === 'start' && index === 0) ||
        (step.dataset.step === 'end' && index === total - 1) ||
        (step.dataset.step === 'middle' && index > 0 && index < total - 1);
      step.classList.toggle('active', isActive);
    });
  }
  updateProgressbarFill(swiper) {
    const progressbar = this.slideshow.querySelector('.fragrance-slider__progressbar');
    if (!progressbar) return;
    let fill = progressbar.querySelector('.swiper-pagination-progressbar-fill');
    if (!fill) {
      fill = document.createElement('span');
      fill.className = 'swiper-pagination-progressbar-fill';
      progressbar.appendChild(fill);
    }
    const progress = (swiper.activeIndex + 1) / swiper.slides.length;
    fill.style.transform = `translate3d(0,0,0) scaleX(${progress}) scaleY(1)`;
  }
  getVisibleVideo(slide) {
    if (!slide) return null;
    return Array.from(slide.querySelectorAll('video')).find((video) => video.offsetParent !== null) || null;
  }
  async safePlay(video) {
    if (!video) return;
    try {
      video.playPromise = video.play();
      await video.playPromise;
    } catch (err) {
      if (err.name !== 'AbortError') console.warn('[fragrance-pyramid-slider] play() failed:', err);
    } finally {
      video.playPromise = null;
    }
  }
  async safePause(video) {
    if (!video) return;
    if (video.playPromise) {
      try {
        await video.playPromise;
      } catch (err) {
        // already handled in safePlay
      }
    }
    video.pause();
  }
  async syncActiveVideo() {
    if (!this.swiper) return;
    const activeSlide = this.swiper.slides[this.swiper.activeIndex];
    const nextVideo = this.isIntersecting ? this.getVisibleVideo(activeSlide) : null;

    if (this.activeVideo && this.activeVideo !== nextVideo) {
      await this.safePause(this.activeVideo);
    }
    this.activeVideo = nextVideo;
    await this.safePlay(nextVideo);
  }
  async handleSlideChange() {
    this.setActiveTab(this.swiper.activeIndex);
    this.updateProgressbarFill(this.swiper);
    this.updateProgressSteps(this.swiper.activeIndex, this.swiper.slides.length);
    await this.syncActiveVideo();
  }
}
customElements.define("fragrance-pyramid-slider", FragrancePyramidSlider);
